import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { PropertyGroup } from '../../components';

import css from './ListingPage.module.css';

const SectionFeaturesMaybe = props => {
  const { options, publicData } = props;
  if (!publicData) {
    return null;
  }

  const selectedOptions = publicData && publicData.workspace ? publicData.workspace : [];

  // If publicData has monitor higher than 0, then add the monitor to the selectedOptions
  if (publicData.monitor > 0) {
    selectedOptions.push('monitor');
  }

  if (publicData.keyboardandmouse > 0) {
    selectedOptions.push('keyboardandmouse');
  }


  return (
    <div className={css.sectionFeatures}>
      <h2 className={css.featuresTitle}>
        <FormattedMessage id="ListingPage.featuresTitle" />
      </h2>
      <PropertyGroup
        id="ListingPage.workspace"
        className={css.workspace}
        itemClassName={css.item}
        options={options}
        selectedOptions={selectedOptions}
      />
    </div>
  );
};

export default SectionFeaturesMaybe;
